import { Schema } from "effect";

export const MessageSmsKind = Schema.Literal(
  "number",
  "attentive",
  "postscript",
  "imessage_gateway",
);
export type MessageSmsKind = typeof MessageSmsKind.Type;

export const MessageSmsService = Schema.Literal(
  "SMS",
  "MMS",
  "RCS",
  "iMessage",
);
export type MessageSmsService = typeof MessageSmsService.Type;
